module.exports = __webpack_public_path__ + "static/img/banner1.b114118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner1.png
// module id = so+l
// module chunks = 1